import axios from "axios";
import { setTokens } from "../../../redux/reducers/authReducers";
import { tokenSchema, type Tokens } from "./tokenSchema";

export const setAuthTokens = (tokens: Tokens | null) => {
  localStorage.setItem("Tokens", JSON.stringify(tokens));
  if (tokens?.access_token) {
    // Apply authorization token to every request if logged in
    axios.defaults.headers.Authorization = `Bearer ${tokens.access_token}`;
  } else {
    // Delete auth header
    delete axios.defaults.headers.Authorization;
    localStorage.removeItem("Tokens");
  }
  return setTokens(tokens);
};

export const getAuthTokens = () => {
  const storageToken = localStorage.getItem("Tokens");
  if (!storageToken) {
    return null;
  }
  const tokens = tokenSchema.safeParse(JSON.parse(storageToken));
  if (tokens.success) {
    return tokens.data;
  }
  return null;
};
